// Generated by CoffeeScript 1.12.6
var EPSILON, _, assert, catalogEnums, helpers, unitConverter;

_ = require('lodash');

assert = require('assert');

unitConverter = require('catalog-market-product-unit-converter');

catalogEnums = require('../enums');

EPSILON = 1e-6;

module.exports = helpers = {
  unitConverter: unitConverter,
  computeCanonicalUnit: function(catalogProduct) {
    var compUnitQtyMaxStr, compUnitQtyRangeStr, compUnitStr, comparisonUnitMaxQuantity, comparisonUnitMinQuantity, comparisonUnitName, packagedItemQuantity, packagedItemStr, packagingFormat, storeByEach;
    assert(catalogProduct != null, 'catalogProduct must be defined');
    if (catalogProduct.legacyUnitLabel != null) {
      return catalogProduct.legacyUnitLabel;
    }
    storeByEach = catalogProduct.storeByEach, comparisonUnitName = catalogProduct.comparisonUnitName, comparisonUnitMinQuantity = catalogProduct.comparisonUnitMinQuantity, comparisonUnitMaxQuantity = catalogProduct.comparisonUnitMaxQuantity, packagingFormat = catalogProduct.packagingFormat, packagedItemQuantity = catalogProduct.packagedItemQuantity;
    if (!storeByEach) {
      return comparisonUnitName;
    }
    if (_.isEmpty(packagingFormat)) {
      packagingFormat = 'each';
    }
    compUnitQtyMaxStr = (comparisonUnitMaxQuantity != null) && comparisonUnitMaxQuantity !== comparisonUnitMinQuantity ? "-" + comparisonUnitMaxQuantity : '';
    compUnitQtyRangeStr = "" + (comparisonUnitMinQuantity != null ? comparisonUnitMinQuantity : 1) + compUnitQtyMaxStr;
    compUnitStr = comparisonUnitName ? (compUnitQtyRangeStr + " " + comparisonUnitName).trim() : '';
    packagedItemStr = packagedItemQuantity && parseInt(packagedItemQuantity) !== 1 ? packagedItemQuantity + " pack" : '';
    return (packagedItemStr + " " + compUnitStr + " " + packagingFormat).trim();
  },
  getCatalogProductStructureType: function(catalogProduct) {
    var activeMarketProducts;
    assert(catalogProduct != null, 'catalogProduct must be defined');
    activeMarketProducts = catalogProduct.marketProducts.filter(function(mp) {
      return mp.status === 'active';
    });
    if (activeMarketProducts.length === 0) {
      return 'non-differentiating';
    }
    if (activeMarketProducts.length === 1 && catalogProduct.needsPrep === false && activeMarketProducts[0]["yield"] !== 1) {
      return 'auto-differentiating yield not 1';
    }
    if (activeMarketProducts.length === 1 && catalogProduct.needsPrep === false) {
      return 'auto-differentiating';
    }
    if (activeMarketProducts.length >= 2 && catalogProduct.fungible === false) {
      return 'non-fungible';
    }
    if (activeMarketProducts.length >= 1 && catalogProduct.fungible === true && catalogProduct.needsPrep === true) {
      return 'needs prep';
    }
    if (activeMarketProducts.length >= 2 && catalogProduct.fungible === true && catalogProduct.needsPrep === false) {
      return 'needs differentiation';
    }
  },
  shouldMigrateToRiversand: function(catalogProduct) {
    var catalogProductStructureType;
    assert(catalogProduct != null, 'catalogProduct must be defined');
    catalogProductStructureType = module.exports.getCatalogProductStructureType(catalogProduct);
    return (!catalogEnums.catalogProductSupplierSlugsNotToMigrate.includes(catalogProduct.vendor.slug)) && catalogEnums.catalogProductStructuresToMigrate.includes(catalogProductStructureType);
  },
  allottedShareSumIsValid: function(catalogProduct) {
    var activeMarketProducts, shareTotal;
    assert(catalogProduct != null, 'catalogProduct must be defined');
    if (catalogProduct.fungible) {
      return true;
    }
    activeMarketProducts = catalogProduct.marketProducts.filter(function(arg) {
      var status;
      status = arg.status;
      return status !== 'dissociated';
    });
    if (activeMarketProducts.length === 0) {
      return true;
    }
    shareTotal = _.sum(activeMarketProducts, function(arg) {
      var allottedShare;
      allottedShare = arg.allottedShare;
      return allottedShare;
    });
    return _.inRange(shareTotal, 1 - EPSILON, 1 + EPSILON);
  }
};
